export default {
  SET_FILTERS (state, filters) {
    state.filters = filters
  },
  SET_FIREWALLS (state, firewalls) {
    state.firewalls = firewalls
  },
  SET_TUNNELS (state, tunnels) {
    state.tunnels = tunnels
  },
  ADD_TUNNEL (state, tunnel) {
    state.tunnel = tunnel
  },
  ADD_FIREWALL (state, firewall) {
    state.firewall = firewall
  },
  ADD_TUNNEL_SETUP_SCRIPT (state, setupScript) {
    state.setupScript = setupScript
  },
  SET_ACTIVE_TUNNEL(state, tunnel) {
    state.activeTunnel = tunnel
  },
}
